import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        pending: "border-transparent bg-status-pending-bg text-status-pending-foreground",
        delivered: "border-transparent bg-status-delivered-bg text-status-delivered-foreground",
        transit: "border-transparent bg-status-transit-bg text-status-transit-foreground",
        cancelled: "border-transparent bg-status-cancelled-bg text-status-cancelled-foreground",
        active: "border-transparent bg-status-delivered-bg text-status-delivered-foreground",
        inactive: "border-transparent bg-muted text-muted-foreground",
        restriction0: "border-transparent bg-restriction-0-bg text-restriction-0-foreground",
        restriction1: "border-transparent bg-restriction-1-bg text-restriction-1-foreground",
        restriction2: "border-transparent bg-restriction-2-bg text-restriction-2-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
